module.exports = __webpack_public_path__ + "static/wordjack-d72097946593a68ed21a250434e6dee3.png";